export class TapeChart
{
	rateId: number;
	tapeChartDate: Date;
}
